const blossomGold = {
    id: "blossom-gold",
    name: "Blossom Gold",
    ornament: "floral",
    radius: "soft",
    fonts: {
        display: "Great Vibes",
        heading: "Cormorant Garamond",
        body: "Marcellus",
    },
    colors: {
        bg: "#faf4ea",
        bgAlt: "#f3ead7",
        surface: "rgba(255,251,242,0.88)",
        primary: "#3a2e24",
        primaryHover: "#2a2118",
        accent: "#b8933f",
        accentSoft: "#ecd9a6",
        rose: "#d29aa1",
        roseDeep: "#b8656e",
        leaf: "#6e7f54",
        text: "#2b221a",
        textMuted: "#7b6a57",
        border: "#e7d9b8",
        buttonText: "#faf4ea",
    },
};

export default blossomGold;
